import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    type: 0,
    returnVoucherDate: "",
    vendorId: "",
    purchaseInvoices: [
        {
            purchaseId: "",
            prItems: [
                {
                    purchaseReturnItemId: "",
                    purchaseReturnId: "",
                    purchaseItemId: "",
                    itemId: "",
                    qty: 0,
                    defectiveQty: 0,
                    totalQty: 0,
                    unitId: "",
                    unitPrice: 0,
                    baseValue: 0,
                    disPer: 0,
                    disAmount: 0,
                    taxableAmount: 0,
                    gstPer: 0,
                    gstAmount: 0,
                    grossAmount: 0,
                    serialNoApp: "",
                    serialNos: []
                }
            ],
            remark: ""
        }
    ],
    dispatchDetails: ""
};

const purchaseReturnSlice = createSlice({
    name: "purchaseReturn",
    initialState,
    reducers: {
        prSelectionInfo: (state, { payload }) => {
            state.type = payload.voucherFor;
            state.returnVoucherDate = payload.returnVoucherDate;
            state.vendorId = payload.vendorId;
        },
        prItemDetails: (state, { payload }) => {
            payload.forEach((item) => {
                console.log("===>", item);
                const existingInvoice = state.purchaseInvoices.find((invoice) => invoice.purchaseId === item.purchaseId);

                if (existingInvoice) {
                    item.prItems.forEach((prItem) => {
                        existingInvoice.prItems.push(prItem);
                    });
                } else {
                    const prItemsArray = item.prItems.map((prItem) => ({
                        ...prItem,
                        purchaseReturnItemId: "",
                        purchaseReturnId: item.purchaseId,
                        remark: ""
                    }));

                    state.purchaseInvoices.push({
                        purchaseId: item.purchaseId,
                        prItems: prItemsArray,
                        remark: ""
                    });
                }
            });
        }


    },
});


const { reducer, actions } = purchaseReturnSlice;

export const {
    prSelectionInfo,
    prItemDetails
} = actions;

export default reducer;
